//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name:'check',
    data() {
        return {
            currentValue:'',
            currenItem:{
                checked: null,
                first: "",
                option: null,
            },
            select:true,
            modeShow:false,
            modeInfo:'',
            modeTitle:''
        }
    },
    props: {
        data: {
            type: Object,
            default:()=>{
                return {
                    value:'',    //默认选中
                    elementCode:element.elementCode,    //
                    elementEnums:element.elementEnums, //
                    elementName:elemnet.elementName,
                    ruleEnums:element.ruleEnums,    //
                    isCount:element.isCount,    //是否为算费因子
                    moduleCode:moduleCode,  // 所属哪个模块
                    isRequired:element.isRequired,   //是否必填
                    list:[],  // 单选/多选的list,
                    freeAmount:'',
                    freeRate:'',
                    desc:'',
                }
            }
        },
        styles:{  //自定义特殊样式
            type: Object,
            default:()=>{
                return {}
            }
        },
        //协议价格
        listMoney:{
            type: Array,
            default:()=>{
                return []

            }
        },
        value:[String, Number,Object]
    },
    computed: {
        // 协议价格 
        price() {
            let price = '' ;
            this.listMoney.map(item =>{ 
                if(item.elementCode == this.data.elementCode){
                    price = item.elementPrice
                }
            })
            return price
        }
    },
    watch:{
        select(valueNew, valueOld){
            let obj = this.getPostData()
            this.$emit('input', obj)
        }
    },
    created() {
        // 初次设置默认值 （不触发算费）
        this.select = false
    },
    mounted(){
        
    },
    methods: {
        showDialog(){
            // console.log(item)
            this.modeShow = true;
            this.modeTitle = this.data.elementName;
            this.modeInfo = this.data.desc
            this.STATISTICS_CONFIG.insur_insurinfoinput_extraserviceinfo_click()
        },
        // 手动点击修改
        change(){
            this.select = !this.select
            const postItem = this.getPostData()
            //发出通知，请求算费结果
            this.$emit("change",postItem);
            // 埋点
            if(this.select){
                this.STATISTICS_CONFIG.insur_insurinfoinput_extraservice_check_click()
            }else{
                this.STATISTICS_CONFIG.insur_insurinfoinput_extraservice_uncheck_click()
            }
        },
        // 格式化
        getPostData(){
            console.log('price',this.price)

            return {
                value:this.select ? '投保':'不投保', //选中值
                last:this.select ? 1 : 0 ,  //选中值
                elementCode:this.data.elementCode,    //
                elementEnums:this.data.elementEnums, //
                elementName:this.data.elementName,
                ruleEnums:this.data.ruleEnums,    //
                price:this.price,
                isCount:this.data.isCount,    //是否为算费因子
                moduleCode:this.data.moduleCode,  // 所属哪个模块
            }    
        }
    },
}
